import { useTypedSelector } from 'src/State/RootReducer'
import useModals from 'src/Hooks/useModals'
import useInstallationExtensionData from '../extensions/use-installation-extension-data'
import { getExtensionContractState } from '../../utils'
import { ExtensionTypes } from '../../types'

/**
 * Returns a callback that opens the Inexogy details modal with its current contract state.
 */
const useOpenInexogyModal = (): (() => void) => {
  const { openInexogyModal } = useModals()
  const installationId = useTypedSelector(state => state.storage.activeInstallation)?.toString() ?? ''
  const { installationExtensionsState, isLoading } = useInstallationExtensionData(installationId)
  const inexogyState = getExtensionContractState(installationExtensionsState, ExtensionTypes.Inexogy)

  return () => openInexogyModal({ extensionState: inexogyState, isLoading })
}

export default useOpenInexogyModal
